<template>
<div @click="navigate($event)" class="px-4  cursor-pointer">
    <div class="rounded overflow-hidden bg-white shadow-lg">
        <div class="px-6 py-4">
            <div class="program-main mb-2 tenant-main-color">
                {{ quiz.title }}
            </div>
            <section class="flex flex-wrap justify-between">
                <p class="program-content text-gray-700 text-base">
                    Reward: {{ quiz.reward }}
                </p>
                <p class="program-content text-gray-700 text-base">
                    Timer: {{ quiz.quiz_timer }}
                </p>
            </section>
            <section class="flex flex-wrap justify-between">
                <p class="program-content text-gray-700 text-base">
                    Allow Retake: {{ quiz.retake_on_request > 1 ? "Yes" : "No" }}
                </p>
                <p class="program-content text-gray-700 text-base">
                    Total Mark: {{ quiz.total_quiz_mark }}
                </p>
            </section>
            <div class=" program-content flex tenant-main-color justify-between">
                <p class="program-content text-gray-700 text-base">
                    Disable on Submit: {{ quiz.disable_on_submit > 1 ? "Yes" : "No" }}
                </p>
                <div>
                    <span id="edit" class="ml-8">Edit</span> |
                    <span id="delete">Delete</span>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapActions
} from "vuex";
export default {
    props: ["quiz"],
    methods: {
        ...mapActions(["tenantDeleteQuiz", 'tenantFetchQuiz']),
        handleClick() {
            this.$confirm({
                message: `Are you sure you want to delete this quiz?`,
                button: {
                    no: "No",
                    yes: "Yes",
                },

                callback: (confirm) => {
                    if (confirm) {
                        this.delete();
                    }
                },
            });
        },
        async delete() {
            let res = await this.tenantDeleteQuiz({
                id: this.quiz.id
            });
            if (res.status === 200 || res.status === 201) {
                this.tenantFetchQuiz();
                this.$Bus.$emit("notify", {
                    type: "success",
                    message: "Quiz deleted succesfully",
                });
                location.reload();
            } else {
                this.$Bus.$emit("notify", {
                    type: "error",
                    message: res.data.errors ?
                        res.data.errors[0].title :
                        "An error occured",
                });
            }
        },
        navigate(e) {
            e.stopImmediatePropagation();
            if (e.target.id == "edit") {
                this.$router.push({
                    name: "tenant-edit-quiz",
                    params: {
                        id: this.quiz.id
                    },
                });
            } else if (e.target.id === "delete") {
                this.handleClick();
            }
        },
    },
};
</script>

<style lang="css" scoped>
.program-main {
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
}

.program-content {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
}
</style>
